export default __webpack_public_path__ + "scene3_2_icone3b754.png";